import BroadcastStatusMark from 'components/widget/BroadcastStatus';

import BlurVideoPlayerCover from './BlurVideoPlayerCover';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import { BroadcastType } from 'graphql/types';

import css from './VideoPlayer.module.scss';

export interface IVideoPlayer {
  url: string;
  coverUrl?: string;
  isAvailable?: boolean;
  broadcasts?: BroadcastType[];

  onRegister?(): void;
}

export default function VideoPlayer(props: IVideoPlayer) {
  const { broadcasts, url, isAvailable = false } = props;
  const broadcastsStatus = useBroadcastsStatus(broadcasts || []);

  return (
    <div className={css.block}>
      <div className={css.playerContainer}>
        {isAvailable ? (
          <>
            <div className={css.onlineMark}>
              <BroadcastStatusMark settings={broadcastsStatus} />
            </div>
            <iframe className={css.player} src={url} allowFullScreen />
          </>
        ) : (
          <BlurVideoPlayerCover {...props} />
        )}
      </div>
    </div>
  );
}
